/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ItemInfo from '../containers/content/ItemInfo';
import ItemPart from '../containers/content/ItemPart';
import StepList from '../containers/content/StepList';
import VoiceList from '../containers/content/VoiceList';
import StillCut from '../containers/content/StillCut';
import Video from '../containers/content/Video';
import StarComment from '../containers/content/StarComment';
import SameGenreContent from '../containers/main/SameGenreContent';
import SameDirectorContent from '../containers/main/SameDirectorContent';
import SameProductionContent from '../containers/main/SameProductionContent';
import TagContent from '../containers/main/TagContent';

// import { StickyContainer, Sticky } from 'react-sticky';
import { Waypoint } from 'react-waypoint';
import { Element } from 'react-scroll';

import { Modal } from 'react-responsive-modal';
import UsePoint from '../containers/point/UsePoint';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from 'react-confirm-alert';         //알럿창(alert confirm)

// import PerfectScrollbar from 'react-perfect-scrollbar';
import { Helmet } from 'react-helmet-async';
// import parse from 'html-react-parser';
// import stripHtml from "string-strip-html";
import { isMobile, isAndroid, isIOS } from 'react-device-detect';
// import ReactPlayer from 'react-player';
// import Mata from '../components/Meta.js'

class Items extends Component {
  state = {
    pointShow: false,
    alertShow: false,
    alertTitle: '',
    alertMsg: '',
    contentSerial: 0,
    contentPartSerial: 0,
    subPartSerial2: 0,
    subPartSerial3: 0,
    payGubun: 'down',
    tabIndex: 0,
    commentNum: 0,
    share: false,
    contentGubun: 0,
    allDownPay: false,
    allVodPay: false,
    zzim: 0,
    alram: 0,
    episodeCount: 0,
    stepCount: 0,
    stillCount: 0,
    goodCount: 0,
    stepShow: false,
    cv_Idx: 0,
    title: '',
    imageL: '',
    synopsis: '',
    opening: '',
    ending: '',
    pv: '',
  };

  componentDidMount = () => {
    const { loginId } = this.props;
    const { match } = this.props;

    // if (isMobile) {
    //   alert(
    //     "PC 전용 사이트로 모바일 해상도를 지원하지 않습니다.\n확인을 누르시면 전용 앱 또는 스토어로 이동합니다."
    //   );
    //   this._movieStore();
    // } else {
    var body = document.querySelector('body');
    body.addEventListener('click', this.clickBodyEvent);

    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }

    //console.log(contentSerial)

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      this._getZzim(contentSerial);
      this._getAlram(contentSerial);
    }
    this._getGoodCount();
    this._topInfo();
    window.scrollTo(0, 0);
    // this._tabChange(1);
    // }
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return (
      this.props.match.params.contentSerial !==
      nextProps.match.params.contentSerial
    );
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    // const { loginId } = this.props;
    console.log(
      this.props.match.params.contentSerial,
      nextProps.match.params.contentSerial
    );
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)
    //console.log(this.props.match)
    //console.log(nextProps.match.params)
    if (
      this.props.match.params.contentSerial !==
      nextProps.match.params.contentSerial
    ) {
      //alert(0)
      var obj = document.querySelector('.detail_view');
      if (obj) {
        //console.log('asdfasdfasdf')
        this._getGoodCount();
        this._topInfo();
        setTimeout(() => {
          obj.scrollTo(0, 0);
        }, 500);
      }
    } else {
      // window.scrollTo(0, 0);
    }
  };
  componentWillUnmount = () => {
    var body = document.querySelector('body');
    body.removeEventListener('click', this.clickBodyEvent);
  };

  _movieStore = () => {
    const { match } = this.props;
    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }

    if (isIOS) {
      console.log('ios');
      setTimeout(function () {
        window.open('https://itunes.apple.com/kr/app/id687631772', '', '');
      }, 1500);

      window.location.href =
        'aniplustv://Detail?contentSerial=' + contentSerial;
    } else if (isAndroid) {
      console.log('andorid');
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);

      window.location.href =
        'aniplustv://Detail?contentSerial=' + contentSerial;
    } else {
      setTimeout(function () {
        window.open(
          'https://play.google.com/store/apps/details?id=com.aniplustv.android',
          '',
          ''
        );
      }, 1500);
    }
  };

  clickBodyEvent = (event) => {
    //let close = 'N'
    var target = event.target;
    var eventTarget = event.currentTarget.querySelector('.detail_view');

    //console.log(target, eventTarget)

    if (target === eventTarget) {
      this._onCloseItem();
    } else {
    }
  };
  _getAlram = async (contentSerial) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getAlramApi(contentSerial);
      if (result) {
        const intReturn = result.data[0].intReturn;

        this.setState({
          alram: intReturn,
        });
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _getAlramApi = (contentSerial) => {
    const { apiUrl, loginId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/contentAlram',
        {
          params: {
            userid: loginId,
            contentSerial: contentSerial,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(4);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _getZzim = async (contentSerial) => {
    // const { loginId } = this.props;

    const result = await this._getZzimApi(contentSerial);
    if (result) {
      const intReturn = result.data[0].intReturn;

      //console.log(intReturn)

      this.setState({
        zzim: intReturn,
      });
    }
  };
  _getZzimApi = (contentSerial) => {
    const { apiUrl, loginId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    //console.log('/contentZzim/'+contentSerial+ '/'+ loginId)
    return axios
      .post(
        apiUrl + '/contentZzim',
        {
          params: {
            userid: loginId,
            contentSerial: contentSerial,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(3);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _setVideo = (opening, ending, pv) => {
    console.log(opening);
    this.setState({
      opening,
      ending,
      pv,
    });
  };
  _onCloseAlertModal = () => {
    this.setState({
      alertShow: false,
    });
  };
  _onShowAlterModal = () => {
    this.setState({
      alertShow: true,
    });
  };
  _onClosePointModal = () => {
    this.setState({
      pointShow: false,
    });
  };
  _onDownloadContent = async () => {
    const { loginId } = this.props;
    const { match } = this.props;
    let contentSerial = match.params.contentSerial;
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      const result = await this._onDownloadContentApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        // const payCount = result.data[0].payCount
        // const contentCount = result.data[0].contentCount
        const payItems = result.data[0].payItems;

        //console.log(intReturn)
        //console.log(payCount)
        //console.log(contentCount)
        //console.log(payItems)

        if (intReturn === 1 || intReturn === 2 || intReturn === 3) {
          //이용권 회원 바로 다운로드.//작품별 결제 회원 다운로드.//일괄 결제내용있음 다운로드
          // 1 멤버십 회원 3 화수별 일괄결제 내역이 있는경우
          //alert('전체 다운로드 로직을 구현하세요...')
          //toast.success('다운로드를 시작합니다.')
          ////console.log('http://www.aniplustv.com/download/down.asp?userid=' + loginId + '&chkSerial=' + payItems + '&gubun=MP4&contentSerial=' + contentSerial)
          //window.open('http://www.aniplustv.com/download/down.asp?userid=' + loginId + '&chkSerial=' + payItems + '&gubun=MP4&contentSerial=' + contentSerial, 'hiddenframe1', 'width=0, height=0, left=0, height=0')
          /*
                    this.setState({
                        payGubun: 'down',
                        pointShow: true,
                        payItems: payItems
                    })
                    */
          this.setState({
            allDownPay: true,
          });
          toast.warn(
            '멤버십 또는 구매내역이 인증되었습니다. 아래 목록에서 원하는 화수의 다운로드 버튼을 클릭 후 다운로드를 진행해주세요'
          );
        } else if (intReturn === 5) {
          //alert(0)

          this.setState({
            payGubun: 'down',
            pointShow: true,
            payItems: payItems,
            chksale: 'all',
          });

          //보유하신 포인트로 결제 후 다운이 가능합니다(10일 무료이용권은 다운로드 서비스가 제한됩니다.).결제 후 첫 관람시점부터 48시간 3회 다운로드가 가능합니다.포인트로 결제 하시겠습니까?
        } else if (intReturn === 10) {
          //alert(0)

          this.setState({
            payGubun: 'down',
            pointShow: true,
            payItems: payItems,
            chksale: 'ppv',
          });

          //보유하신 포인트로 결제 후 다운이 가능합니다(10일 무료이용권은 다운로드 서비스가 제한됩니다.).결제 후 첫 관람시점부터 48시간 3회 다운로드가 가능합니다.포인트로 결제 하시겠습니까?
        } else if (intReturn === 6) {
          //멤버십 회원이 아니거나 보유하신 포인트가 부족합니다.
          toast.warn(
            '멤버십을 보유하지 않았거나 보유하신 포인트가 부족합니다.'
          );
          /*
                    this.setState({
                        payGubun: 'down',
                        pointShow: true,
                        payItems: payItems,
                        chksale: 'ppv'
                    })
                    */
        } else if (intReturn === 7) {
          //해당 작품은 이용권으로 다운로드가 불가능합니다.(포인트로만 이용가능)
          toast.warn(
            '해당 작품은 이용권으로 다운로드가 불가능합니다.(저작권사의 요청으로 포인트로만 이용가능)'
          );
          this.setState({
            payGubun: 'down',
            pointShow: true,
            payItems: payItems,
            chksale: 'ppv',
          });
        } else if (intReturn === -2) {
          //19세미만은 관람하실 수 없습니다.
          toast.warn('19세 미만은 관람하실 수 없습니다.');
        } else if (intReturn === -3) {
          //전체화수 다운로드 구매는 종영작만 가능합니다.
          /*
                    this.setState({
                        payGubun: 'down',
                        pointShow: true,
                        payItems: payItems,
                        chksale: 'ppv'
                    })
                    */
          toast.warn('전체화수 다운로드 구매는 종영작만 가능합니다.');
        }
      }
    }
  };
  _onDownloadContentApi = () => {
    const { match, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    let contentSerial = match.params.contentSerial;
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    const { loginId, apiUrl } = this.props;

    return axios(
      apiUrl +
        '/downloadContent?userid=' +
        loginId +
        '&contentSerial=' +
        contentSerial +
        '&authId=' +
        authId,
      {
        headers: {
          Authorization: 'bearer ' + at,
        },
      }
    )
      .then((response) => response)
      .catch((error) => {
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
        //console.log('error..')
      });
  };
  _refreshToken = async (gubun) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId, match } =
      this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 0) {
        this._onDownloadContent();
      } else if (gubun === 1) {
        this._onVodContent();
      } else if (gubun === 2) {
        this._setPointUse();
      } else if (gubun === 3) {
        this._getZzim(contentSerial);
      } else if (gubun === 4) {
        this._getAlram(contentSerial);
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onVodContent = async () => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
      /*
            this.setState({
                alertTitle: '로그인',
                alertMsg: '로그인 후 이용해 주세요',
                alertShow: true
            })
            */
    } else {
      const result = await this._onVodContentApi();

      if (result) {
        const intReturn = result.data[0].intReturn;
        // const payCount = result.data[0].payCount
        // const contentCount = result.data[0].contentCount
        const payItems = result.data[0].payItems;
        //console.log(intReturn)
        //alert(0)
        if (intReturn === 1 || intReturn === 3) {
          //이용권 회원 바로 다운로드.////일괄 결제내용있음 다운로드
          //alert('VOD 구매확인')
          toast.success(
            '멤버십 또는 구매내역이 인증되었습니다. 아래 목록에서 원하는 화수를 감상 하세요!'
          );

          this.setState({
            allVodPay: true,
          });
        } else if (intReturn === 5) {
          this.setState({
            payGubun: 'vod',
            pointShow: true,
            payItems: payItems,
            chksale: 'all',
          });
          //보유하신 포인트로 결제 후 다운이 가능합니다(10일 무료이용권은 다운로드 서비스가 제한됩니다.).결제 후 첫 관람시점부터 48시간 3회 다운로드가 가능합니다.포인트로 결제 하시겠습니까?
        } else if (intReturn === 10) {
          this.setState({
            payGubun: 'vod',
            pointShow: true,
            payItems: payItems,
            chksale: 'ppv',
          });
          //보유하신 포인트로 결제 후 다운이 가능합니다(10일 무료이용권은 다운로드 서비스가 제한됩니다.).결제 후 첫 관람시점부터 48시간 3회 다운로드가 가능합니다.포인트로 결제 하시겠습니까?
        } else if (intReturn === 6) {
          toast.warn(
            '멤버십을 보유하지 않았거나 보유하신 포인트가 부족합니다.'
          );

          //멤버십 회원이 아니거나 보유하신 포인트가 부족합니다.
        } else if (intReturn === 7) {
          toast.warn('해당 작품은 이용권으로 이용이 불가능합니다.');
          //해당 작품은 이용권으로 다운로드가 불가능합니다.(포인트로만 이용가능)
        } else if (intReturn === -2) {
          //19세미만은 관람하실 수 없습니다.
          toast.warn('19세 미만은 관람하실 수 없습니다.');
        } else if (intReturn === -3) {
          //전체화수 다운로드 구매는 종영작만 가능합니다.
          toast.warn('전체화수 VOD 구매는 종영작만 가능합니다.');
        } else if (intReturn === -1) {
          toast.warn('서비스중인 작품이 아닙니다.');
          //서비스 중인 작품이 아닙니다.
        } else if (intReturn === -1000) {
          toast.warn('서비스가 종료되었습니다.');
        }
      }
    }
  };
  _onVodContentApi = () => {
    const { loginId, apiUrl, authId, match, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }

    return axios(
      apiUrl +
        '/vodContent?userid=' +
        loginId +
        '&contentSerial=' +
        contentSerial +
        '&authId=' +
        authId,
      {
        headers: {
          Authorization: 'bearer ' + at,
        },
      }
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(1);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _onCloseModal = () => {
    this.setState({
      pointShow: false,
    });
  };
  _setPointUse = async () => {
    const { loginId } = this.props;
    const { payGubun } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._setPointUseApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        if (intReturn === 0) {
          if (payGubun === 'down') {
            toast.success(
              '포인트결제가 성공적으로 완료되었습니다. 아래 목록에서 다운 버튼을 클릭해주세요'
            );
            this.setState({
              pointShow: false,
              allDownPay: true,
            });
          } else {
            toast.success(
              '포인트결제가 성공적으로 완료되었습니다. 아래 목록에서 플레이 버튼을 클릭해주세요'
            );
            this.setState({
              pointShow: false,
              allVodPay: true,
            });
          }

          ////console.log('다운로드 시작.')
        } else {
          //alert('오류가 발생했습니다.')
          toast.error('오류가 발생했습니다.');
        }
      }
    }
  };
  _setPointUseApi = () => {
    const { payGubun, payItems, chksale } = this.state;
    const { apiUrl, loginId, match, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    let contentSerial = match.params.contentSerial;
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }

    //console.log(apiUrl + '/setUsePoint?userid=' + loginId + '&CheckedItems=' + payItems + ',' + '&contentSerial=' + contentSerial + '&gubun=' + payGubun + '&chksale=' + chksale )
    //return axios(apiUrl + '/setUsePoint?userid=' + loginId + '&contentSerial=' + contentSerial + '&CheckedItems=' + payItems + '&gubun=' + payGubun + '&chksale=' + chksale)

    return axios
      .post(
        apiUrl + '/setUsePoint',
        {
          params: {
            userid: loginId,
            authId: authId,
            CheckedItems: payItems,
            contentSerial: contentSerial,
            gubun: payGubun,
            chksale: chksale,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }

        //alert('포인트 정보를 로드중 오류가 발생했습니다.')
      });
  };
  _tabChange = (tabIndex) => {
    document.getElementById('tab' + tabIndex).scrollIntoView();
    this.setState({
      tabIndex,
    });
  };
  _handleWaypointEnter = (tabIndex) => {
    //console.log(tabIndex)
    this.setState({
      tabIndex,
    });
  };
  _handleWaypointLeave = (tabIndex) => {
    //console.log(tabIndex)
    this.setState({
      tabIndex,
    });
  };
  _commentCount = (num) => {
    this.setState({
      commentNum: num,
    });
  };
  _episodeCount = (num) => {
    this.setState({
      episodeCount: num,
    });
  };
  _stepCount = (num) => {
    this.setState({
      stepCount: num,
    });
  };
  _stillCount = (num) => {
    this.setState({
      stillCount: num,
    });
  };

  _toggleShare = () => {
    const { share } = this.state;
    this.setState({
      share: !share,
    });
  };
  _onNaver = () => {
    window.open(
      'http://share.naver.com/web/shareView.nhn?url=' +
        encodeURIComponent(document.URL) +
        '&title=' +
        encodeURIComponent(document.title),
      'naversharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onTwitter = () => {
    const { match } = this.props;
    const { title } = this.state;
    let contentSerial = match.params.contentSerial;
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    const url = 'https://www.aniplustv.com/items/' + contentSerial;

    window.open(
      'https://twitter.com/intent/tweet?text=[%EA%B3%B5%EC%9C%A0]%20' +
        encodeURIComponent(url) +
        '%20-%20' +
        encodeURIComponent(title ? title : document.title),
      'twittersharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onFacebook = () => {
    const { match } = this.props;
    const { title } = this.state;
    let contentSerial = match.params.contentSerial;
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    const url = 'https://www.aniplustv.com/items/' + contentSerial;

    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) +
        '&t=' +
        encodeURIComponent(title ? title : document.title),
      'facebooksharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onInstar = () => {
    const { match } = this.props;
    // const { title } = this.state
    let contentSerial = match.params.contentSerial;
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    const url = 'https://www.aniplustv.com/items/' + contentSerial;

    window.open(
      'https://plus.google.com/share?url=' + encodeURIComponent(url),
      'googleplussharedialog',
      'menubar=no,toolbar=no,resizable=yes, scrollbars=yes,height=350,width=600'
    );
  };
  _onKakao = () => {
    const { match } = this.props;
    // const { title } = this.state
    let contentSerial = match.params.contentSerial;
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    const url = 'https://www.aniplustv.com/items/' + contentSerial;

    window.open(
      'https://story.kakao.com/s/share?url=' + encodeURIComponent(url),
      'kakaostorysharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes, height=400,width=600'
    );
  };
  _onCloseItem = () => {
    const { setContentSerial, history, contentSerial } = this.props;
    console.log(contentSerial);
    if (
      contentSerial === 0 ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      //console.log('back')
      /*
            if ('scrollRestoration' in history) {
                // Back off, browser, I got this...
                history.scrollRestoration = 'manual';
            }
            */
      history.goBack();
    } else {
      //console.log('set')
      setContentSerial(0);
    }

    //history.goBack()
  };

  _onContentGubun = (gubun) => {
    this.setState({
      contentGubun: gubun,
    });
  };
  _onChangeAllDown = () => {
    this.setState({
      allDownPay: true,
    });
  };
  _onChangeAllVod = () => {
    this.setState({
      allVodPay: true,
    });
  };
  _onTitle = (title, imageL, synopsis) => {
    /*
        this.setState({
            title,
            imageL,
            synopsis: synopsis === '' || synopsis === undefined || synopsis === null ? '' : stripHtml(synopsis)
        })
        */
  };

  _toggleWish = async () => {
    const { match } = this.props;
    // const { onInit } = this.props.childProps;
    const { loginId } = this.props;

    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }

    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      const result = await this._toggleWishApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      this.setState({
        zzim: intReturn,
      });
      if (intReturn === 100) {
        toast.success('찜하기 성공~!');
      } else {
        toast.warn('찜하기 해제~!');
      }
    }
  };
  _toggleWishApi = () => {
    const { match } = this.props;
    const { apiUrl, loginId } = this.props;
    //const { contentSerial } = this.props.childProps;
    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    return axios
      .post(apiUrl + '/wishToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };

  _toggleAlram = async () => {
    const { loginId } = this.props;
    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      const result = await this._toggleAlramApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      this.setState({
        alram: intReturn,
      });
      if (intReturn === 100) {
        toast.success(
          '알림 등록 성공~! 모바일 APP을 통해서만 받으실 수 있습니다.'
        );
      } else {
        toast.warn('알림 해제 성공~!');
      }
    }
  };
  _toggleAlramApi = () => {
    const { match } = this.props;
    const { apiUrl, loginId } = this.props;
    //const { contentSerial } = this.props.childProps;
    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }

    return axios
      .post(apiUrl + '/alramToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };

  _getGoodCount = async () => {
    //const { contentSerial } = this.props.childProps;
    const { match } = this.props;
    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
    } else {
      const result = await this._getGoodCountApi();
      const intReturn = result.data[0].intReturn;
      //console.log(result)
      if (intReturn === 0) {
        this.setState({
          goodCount: result.data[0].listData[0].cnt,
          goodSerial: result.data[0].listData[0].goodSerial,
        });
      } else {
        this.setState({
          goodCount: 0,
          goodSerial: 0,
        });
      }
    }
  };
  _getGoodCountApi = () => {
    const { apiUrl } = this.props;
    //const { contentSerial } = this.props.childProps;
    const { match } = this.props;
    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    return axios.post(apiUrl + '/goodCount', {
      params: {
        contentSerial: contentSerial,
      },
    });
  };

  _topInfo = async () => {
    //const { contentSerial } = this.props.childProps;
    const { match } = this.props;
    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
    } else {
      const result = await this._topInfoApi();
      const intReturn = result.data[0].intReturn;
      const topInfo = result.data[0].listData;
      //console.log(result)
      if (intReturn === 0) {
        this.setState({
          title: topInfo[0].title,
          imageL: topInfo[0].imageL,
          synopsis: topInfo[0].synopsis,
          topInfo,
        });
      } else {
        this.setState({
          title: '',
          imageL: '',
          synopsis: '',
        });
      }
    }
  };
  _topInfoApi = () => {
    const { apiUrl } = this.props;
    //const { contentSerial } = this.props.childProps;
    const { match } = this.props;
    let contentSerial = match.params.contentSerial;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
    }
    return axios.post(apiUrl + '/topInfo', {
      params: {
        contentSerial: contentSerial,
      },
    });
  };

  _goods = (goodSerial) => {
    if (goodSerial === 0) {
      toast.warn('관련된 상품이 존재하지 않습니다.');
    } else {
      window.open('https://shop.aniplustv.com/list/A?i=' + goodSerial, '', '');
    }
    //alert(0)
  };
  _director = () => {
    console.log('director');
  };
  _stepShow = () => {
    this.setState({
      stepShow: true,
    });
  };
  _stepClose = () => {
    this.setState({
      stepShow: false,
    });
  };
  _stepClick = (cv_Idx) => {
    this.setState({
      stepShow: true,
      cv_Idx: cv_Idx,
    });
  };
  render() {
    const {
      pointShow,
      payGubun,
      tabIndex,
      commentNum,
      share,
      payItems,
      contentGubun,
      allDownPay,
      allVodPay,
      chksale,
      zzim,
      alram,
      episodeCount,
      stepCount,
      stillCount,
      goodCount,
      goodSerial,
      stepShow,
      cv_Idx,
      title,
      imageL,
      synopsis,
      keyword,
      opening,
      ending,
      pv,
    } = this.state;
    const { match, imgUrl } = this.props;
    let pos = '';
    let contentSerial;
    let title1, imageL1, keyword1, synopsis1;
    if (match) {
      contentSerial = match.params.contentSerial;
      pos = 'pop'; //line
    }

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      contentSerial = this.props.childProps.contentSerial;
      pos = 'pop';
    }

    if (parseInt(contentSerial) === 2647) {
      title1 = '스파이 패밀리';
      imageL1 =
        'https://ah9szoaj9w.ecn.cdn.ofs.kr/images/tvee-admin/content/CS_20220327211015.jpg';
      keyword1 = '스파이 패밀리, 스파이, 가족, 첩보, 코믹';
      synopsis1 =
        '사람은 누구나 아무에게도<br />보여줄 수 없는 자신을 갖고 있다.<br /><br />세계 각국이 물밑에서 치열하게 정보전을 펼치는 시대.<br />오스타니아와 웨스탈리스는 십수 년간에 걸쳐 냉전 상태에 있었다.<br /><br />웨스탈리스의 정보국 대동과 &#39;WISE&#39; 소속의 수완가 스파이인 &#39;황혼&#39; 은<br />동서 평화를 위협하는 위험인물, 오스타니아의 국가통일당 총재 도노반 데스몬드의 동향을 살피기 위해<br />어떤 극비 임무를 수행하게 된다.<br /><br />그 이름은 오퍼레이션 &#39;올빼미&#39;.<br /><br />임무 내용은 &quot;일주일 이내에 가족을 만들어,<br />데스몬드의 아들이 다니는 명문 학교의 친목회에 잠입하라&quot;.<br /><br />&#39;황혼&#39; 은 정신과 의사 로이드 포저로 위장하고 가족을 만들게 된다.<br /><br />하지만, 그가 만난 딸 아냐는 마음을 읽을 수 있는 초능력자, 아내 요르는 암살자였다!<br />3명의 이해가 일치하여 서로 정체를 숨기면서 함께 생활하게 되는데.<br /><br />해프닝 연속인 임시 가족에게,&nbsp;<br />세계의 평화는 맡겨졌다.<br />&nbsp;...';
    } else if (parseInt(contentSerial) === 2336) {
      title1 = '주술회전';
      imageL1 =
        'https://ah9szoaj9w.ecn.cdn.ofs.kr/images/tvee-admin/content/CS_20201228200033.jpg';
      keyword1 = '주술회전, 성장, 요괴, 괴물, 이능력, 열혈, 교복, 판타지, 액션';
      synopsis1 =
        '소년은 싸운다 올바른 죽음을 위해<br /><br />쓰라린 고통, 후회, 치욕<br />인간으로부터 흘러나온 부정적인 감정이 저주로 변해 일상에 숨어든다.<br />저주는 세상에 만연한 재앙의 근원이며, 최악의 경우 인간을 죽음으로 이끈다.<br />그리고 저주는 저주로밖에 없앨 수 없다.&nbsp;<br /><br />경이적인 신체능력을 가진 소년 이타도리 유지는 아주 평범한 고등학생이었지만,<br />어느 날 &#39;저주&#39;에 습격당한 친구를 구하기 위해 특급 주물 &#39;양면 스쿠나의 손가락&#39;을 먹고 영혼에 저주가 깃들게 된다.<br /><br />저주인 &#39;양면 스쿠나&#39;와 몸을 공유하게 된 이타도리는 최강의 주술사인 고죠 사토루의 안내로<br />저주에 대항하는 전문 기관인 &#39;도쿄 도립 주술 고등전문학교&#39;에 편입하게 되는데......<br /><br />저주를 없애기 위해 저주가 된 소년의 돌이킬 수 없는<br />장렬한 이야기가 움직이기 시작한다....';
    } else if (parseInt(contentSerial) === 1337) {
      title1 = '진격의 거인';
      imageL1 =
        'https://ah9szoaj9w.ecn.cdn.ofs.kr/images/tvee-admin/content/CS_20150916155001.jpg';
      keyword1 = '진격의 거인, 거인, 진격, 액션, 판타지, 파괴';
      synopsis1 =
        '100여년 전, 갑자기 나타난 거인들에 의해 멸종 위기에 처한 인류는 살아남기 위해 50m의 거대한 벽을 쌓고 그 안에서 숨죽이며 살아가고 있었다. 그러던 어느 날, 초대형 거인의 등장으로 벽은 무너지고, 거인들이 벽 안으로 들어와 사람들을 잡아먹기 시작하는데...절규와 죽음으로 가득한 절망적인 상황에서 거인에게 소중한 사람들을 빼앗긴 엘런은 복수를 맹세한다....';
    } else if (parseInt(contentSerial) === 2495) {
      title1 = '바니타스의 수기';
      imageL1 =
        'https://ah9szoaj9w.ecn.cdn.ofs.kr/images/tvee-admin/content/CS_20210624110515.jpg';
      keyword1 = '바니타스의 수기, 바니타스';
      synopsis1 =
        '이것은 멸망해가는 흡혈귀의 이야기<br /><br />인간과 흡혈귀가 존재하는 19세기 프랑스<br />흡혈귀 청년 노에는 흡혈귀를 저주한다고 알려진 마도서 바니타스의 서를 찾아서 파리로 향한다.<br />파리로 향하던 도중 비행선 안에서 노에는 어떤 사건과 조우한다.<br /><br />그리고 그 혼란 속에서 노에의 앞에 나타난 것은 자신을 흡혈귀 전문의라고 자칭하는 인간 바니타스였다.<br />바니타스의 손에는 노에가 찾고 있던 저주의 마도서 &#39;바니타스의 서 가 있었다.<br /><br />두 사람의 만남으로 시작되는 저주와 구원의 흡혈귀 이야기가 지금 막을 연다....';
    } else {
      title1 = title;
      imageL1 = imageL;
      keyword1 = keyword;
      synopsis1 = synopsis;
    }
    //console.log(pos)
    //console.log(contentSerial)
    return (
      <Fragment>
        {contentSerial ? (
          <Helmet>
            <title>{`${title1} - 애니플러스`}</title>
            <meta name="robots" content="index,follow" />
            <meta name="title" content={`${title1} - 애니플러스`} />
            <meta name="description" content={`${title1} - ${synopsis1}`} />
            <meta name="keywords" content={`${title1} ${keyword1}`} />
            <link
              rel="canonical"
              href={`https://www.aniplustv.com/items/${contentSerial}`}
            />

            <meta property="og:site_name" content="애니플러스" />
            <meta property="og:title" content={`${title1} 애니플러스`} />
            <meta
              property="og:description"
              content={`${title1} - ${synopsis1}`}
            />
            <meta
              property="og:url"
              content={`https://www.aniplustv.com/items/${contentSerial}`}
            />
            <meta property="og:image" content={`${imageL}`} />

            <meta
              name="twitter:domain"
              content={`https://www.aniplustv.com/items/${contentSerial}`}
            />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={`${title1} 애니플러스`} />
            <meta
              name="twitter:description"
              content={`${title1} - ${synopsis1}`}
            />
            <meta property="twitter:image" content={`${imageL1}`} />
          </Helmet>
        ) : null}
        {/* {isMobile ? (
          <div
            style={{
              color: "#fff",
              textAlign: "center",
              paddingTop: 100,
            }}
          >
            <p>
              <img src="/img/logo.png" style={{ width: 130 }} />
            </p>
            <p style={{ paddingTop: 20, fontSize: 15 }}>
              모바일에서 지원되지 않는 페이지입니다.
            </p>
            <p style={{ fontSize: 15 }}>전용앱을 이용해주세요.</p>
            <p
              onClick={this._movieStore}
              style={{
                paddingTop: 15,
                color: "#ff5d24",
                fontSize: 15,
                fontWeight: 800,
              }}
            >
              전용앱으로 열기
            </p>
          </div>
        ) : ( */}
        <>
          <div className={pos === 'pop' ? 'detail_layer_pop' : null}>
            <div className="detail_view">
              {' '}
              {/*style={pos === 'pop' ? {overflowY: 'scroll'}: {overflowY: 'hidden'}}*/}
              {pos === 'pop' ? (
                <div
                  className="detail_layer_close"
                  style={{ cursor: 'pointer' }}
                  onClick={this._onCloseItem}
                >
                  <img src={imgUrl + '/img/detail_img/close_1.png'} />
                </div>
              ) : null}
              <div
                className={
                  pos === 'pop'
                    ? 'detail_view_layer'
                    : 'detail_layer_pop detail_view_layer'
                }
              >
                <div className="detail_menu">
                  <div>
                    {/* <button
                      type="button"
                      onClick={this._toggleWish}
                      className={zzim === 100 ? 'btn_ico active' : 'btn_ico'}
                    >
                      <i className="ico_like"></i>찜
                    </button>
                    <button
                      type="button"
                      className={share ? 'btn_ico active' : 'btn_ico'}
                      onClick={this._toggleShare}
                    >
                      <i className="ico_share"></i>공유
                    </button>
                    <button
                      type="button"
                      className={alram === 100 ? 'btn_ico active' : 'btn_ico'}
                      onClick={this._toggleAlram}
                    >
                      <i className="ico_alram"></i>알림
                    </button>

                    <button
                      type="button"
                      className={goodCount > 0 ? 'btn_ico active' : 'btn_ico'}
                      onClick={() => this._goods(goodSerial)}
                    >
                      <i className="ico_box"></i>상품({goodCount})
                    </button> */}

                    {/* <span
                      style={{ cursor: 'pointer' }}
                      onClick={this._toggleWish}
                    >
                      <em className={zzim === 100 ? 'on' : null}>즐겨찾기</em>
                    </span> */}
                    <span className="shareBox">
                      {/*<em className={share ? "on" : null} style={{cursor: 'pointer'}} onClick={this._toggleShare}>공유</em>*/}
                      {share ? (
                        <p>
                          <a
                            style={{ cursor: 'pointer' }}
                            onClick={this._onTwitter}
                          >
                            <img
                              src={imgUrl + '/img/detail_img/sns_icon1.png'}
                            />
                          </a>
                          <a
                            style={{ cursor: 'pointer' }}
                            onClick={this._onFacebook}
                          >
                            <img
                              src={imgUrl + '/img/detail_img/sns_icon2.png'}
                            />
                          </a>
                          {/*<a style={{cursor: 'pointer'}} onClick={this._onInstar}><img src="/img/detail_img/sns_icon3.png"/></a>*/}
                          <a
                            style={{ cursor: 'pointer' }}
                            onClick={this._onKakao}
                          >
                            <img
                              src={imgUrl + '/img/detail_img/sns_icon4.png'}
                            />
                          </a>
                          <a
                            style={{ cursor: 'pointer' }}
                            onClick={this._onNaver}
                          >
                            <img
                              src={imgUrl + '/img/detail_img/sns_icon5.png'}
                            />
                          </a>
                        </p>
                      ) : null}
                    </span>
                    {/*<a href="#" className="home_a"><em>home</em></a>*/}
                  </div>

                  {/*
                                <div>
                                    <span style={{cursor: 'pointer'}} onClick={this._toggleWish}><em className={ zzim === 100 ? "on" : null}>즐겨찾기</em></span>
                                   
                                    <span>
                                        <em className={share ? "on" : null} style={{cursor: 'pointer'}} onClick={this._toggleShare}>공유</em>
                                        { share ? (
                                            <p>
                                                <a style={{cursor: 'pointer'}} onClick={this._onTwitter}><img src="/img/detail_img/sns_icon1.png"/></a>
                                                <a style={{cursor: 'pointer'}} onClick={this._onFacebook}><img src="/img/detail_img/sns_icon2.png"/></a>
                                                <a style={{cursor: 'pointer'}} onClick={this._onInstar}><img src="/img/detail_img/sns_icon3.png"/></a>
                                                <a style={{cursor: 'pointer'}} onClick={this._onKakao}><img src="/img/detail_img/sns_icon4.png"/></a>
                                                <a style={{cursor: 'pointer'}} onClick={this._onNaver}><img src="/img/detail_img/sns_icon5.png"/></a>
                                            </p>
                                        ) : null }
                                    </span>
                                            
                                    <Link to="/" className="home_a"><em>home</em></Link>
                                </div>
                                */}
                </div>

                {/*상세 Top */}
                <ItemInfo
                  contentSerial={contentSerial}
                  buyDownload={this._onDownloadContent}
                  buyVod={this._onVodContent}
                  onContentGubun={this._onContentGubun}
                  allDownPay={allDownPay}
                  allVodPay={allVodPay}
                  onChangeAllDown={this._onChangeAllDown}
                  onChangeAllVod={this._onChangeAllVod}
                  onTitle={this._onTitle}
                  onDirector={this._director}
                  alram={alram}
                  toggleAlram={this._toggleAlram}
                  setVideo={this._setVideo}
                />
                {/*상세 Top */}
                {/*
                            <StickyContainer>
                            <Sticky topOffset={0}>
                            {({
                                style, isSticky
                            }) => (
                            */}
                <div className="detil_tab">
                  <ul>
                    <li>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => this._tabChange(1)}
                        className={tabIndex === 1 ? 'on' : null}
                      >
                        에피소드
                        {episodeCount === 0 ? null : '(' + episodeCount + ')'}
                      </a>
                    </li>
                    {/* <li>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => this._tabChange(1)}
                        className={tabIndex === 1 ? 'on' : null}
                      >
                        줄거리
                       
                      </a>
                    </li> */}
                    <li>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => this._tabChange(2)}
                        className={tabIndex === 2 ? 'on' : null}
                      >
                        등장인물
                        {stepCount === 0 ? null : '(' + stepCount + ')'}
                      </a>
                    </li>
                    <li>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => this._tabChange(3)}
                        className={tabIndex === 3 ? 'on' : null}
                      >
                        스틸컷
                        {stillCount === 0 ? null : '(' + stillCount + ')'}
                      </a>
                    </li>
                    {/* <li>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => this._tabChange(4)}
                        className={tabIndex === 4 ? 'on' : null}
                      >
                        영상
                      </a>
                    </li> */}
                    <li>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => this._tabChange(4)}
                        className={tabIndex === 4 ? 'on' : null}
                      >
                        작품평
                        {commentNum === 0 ? null : '(' + commentNum + ')'}
                      </a>
                    </li>
                  </ul>
                </div>
                {/*
                             )}
                             </Sticky>
                             */}
                <div className="pop_padding_70">
                  <Waypoint
                    onEnter={() => this._handleWaypointEnter(0)}
                    //onLeave={()=>this._handleWaypointLeave(0)}
                  />
                  {/*바 베너 주석*/}
                  {/*<div className="pop_promotion_div1"><img src="/img/detail_img/baenr_img1.png"/></div>*/}

                  {/*에피소드 */}
                  <Waypoint
                    onEnter={() => this._handleWaypointEnter(1)}
                    //onLeave={()=>this._handleWaypointLeave(0)}
                  />
                  <Element name="tab1" id="tab1"></Element>
                  {/* <div
                    style={{ color: '#fff', fontSize: 15, lineHeight: 3 }}
                    dangerouslySetInnerHTML={{ __html: synopsis }}
                  ></div> */}

                  <ItemPart
                    contentSerial={contentSerial}
                    onCloseModal={this.props.childProps.onCloseModal}
                    buyDownload={this._onDownloadContent}
                    buyVod={this._onVodContent}
                    contentGubun={contentGubun}
                    allDownPay={allDownPay}
                    allVodPay={allVodPay}
                    onChangeAllDown={this._onChangeAllDown}
                    onChangeAllVod={this._onChangeAllVod}
                    onEpisodeCount={this._episodeCount}
                  />

                  {/*에피소드 */}
                  {/*<div className="pop_promotion_div2"><img src="/img/detail_img/baenr_img2.png"/></div>*/}
                  {/*등장인물 */}
                  <Waypoint
                    onEnter={() => this._handleWaypointEnter(2)}
                    //onLeave={()=>this._handleWaypointLeave(0)}
                  />
                  <Element name="tab2" id="tab2"></Element>

                  <StepList
                    contentSerial={contentSerial}
                    onStepCount={this._stepCount}
                    stepClick={this._stepClick}
                  />
                  {/*등장인물*/}
                  {/*스틸컷*/}
                  <Waypoint
                    onEnter={() => this._handleWaypointEnter(3)}
                    //onLeave={()=>this._handleWaypointLeave(0)}
                  />
                  <Element name="tab3" id="tab3"></Element>
                  <StillCut
                    contentSerial={contentSerial}
                    onStillCount={this._stillCount}
                  />
                  {/*스틸컷*/}
                  {/*<div className="pop_promotion_div3"><img src="/img/detail_img/baenr_img3.png"/></div>*/}
                  {/*리뷰*/}
                  <Waypoint
                    onEnter={() => this._handleWaypointEnter(4)}
                    //onLeave={()=>this._handleWaypointLeave(0)}
                  />
                  <Element name="tab4" id="tab4"></Element>

                  {/* <Video opening={opening} ending={ending} pv={pv} /> */}

                  <StarComment
                    contentSerial={contentSerial}
                    onCommentCount={this._commentCount}
                  />
                  {/*리뷰*/}

                  <Modal
                    open={stepShow}
                    showCloseIcon={true}
                    onClose={this._stepClose}
                    closeOnOverlayClick={true}
                    closeOnEsc={false}
                    center
                    styles={{ modal: { backgroundColor: 'black' } }}
                  >
                    <VoiceList
                      contentSerial={contentSerial}
                      cv_Idx={cv_Idx}
                      stepClose={this._stepClose}
                    />
                  </Modal>
                </div>
                <Waypoint
                  onEnter={() => this._handleWaypointEnter(0)}
                  //onLeave={()=>this._handleWaypointLeave(0)}
                />
                <div className="pop_etc_list">
                  {/*
                <div>
                  <SameDirectorContent contentSerial={contentSerial} />
                </div>
                <div>
                  <SameGenreContent contentSerial={contentSerial} />
                </div>
                <div>
                  <SameProductionContent contentSerial={contentSerial} />
                </div>
                */}
                  <TagContent />
                </div>
                {/*</StickyContainer>*/}
              </div>
            </div>
          </div>

          {/*
                <div style={{color: '#ffffff', paddingTop: 150}}>
                    <p>itemInfo</p>
                    <ItemInfo 
                        contentSerial={contentSerial}
                    />
                    
                   
                    <p>subTitle list</p>
                    <ItemPart 
                        contentSerial={contentSerial}
                        onCloseModal = {this.props.childProps.onCloseModal}
                    />
                    <p>....</p>
                    <button onClick={this._onDownloadContent}>전체 Download 구매</button>
                    <button onClick={this._onVodContent}>전체 VOD 구매</button>
                    <Modal open={alertShow} onClose={this._onCloseAlertModal} center>
                        <h2>{alertTitle}</h2>
                        <p>
                            {alertMsg}
                        </p>
                    </Modal> 
                
                    <Modal 
                     open={pointShow} onClose={this._onCloseModal} closeOnOverlayClick={false} closeOnEsc={false} center
                    >
                    <UsePoint
                        contentSerial={contentSerial}
                        //contentPartSerial={contentPartSerial}
                        //subPartSerial2={subPartSerial2}
                        //subPartSerial3={subPartSerial3}
                        payGubun={payGubun}
                        chksale="all"
                        onPointUse = {this._setPointUse} 

                    />
                    </Modal> 

                </div>
                */}

          {/*<iframe width="0" height="0" name="hiddenframe1" style={{display: "none"}}></iframe>*/}
          <Modal
            open={pointShow}
            showCloseIcon={false}
            onClose={this._onCloseModal}
            closeOnOverlayClick={false}
            closeOnEsc={false}
            center
          >
            <UsePoint
              contentSerial={contentSerial}
              //contentPartSerial={contentPartSerial}
              subPartSerial2={payItems}
              //subPartSerial3={subPartSerial3}
              payGubun={payGubun}
              chksale={chksale}
              onPointUse={this._setPointUse}
              onClose={this._onCloseModal}
            />
          </Modal>

          {/*
               <Modal open={alertShow} onClose={this._onCloseAlertModal} center>
                    <h2>{alertTitle}</h2>
                    <p>
                        {alertMsg}
                    </p>
                </Modal> 
            
                <Modal 
                    open={pointShow} onClose={this._onCloseModal} closeOnOverlayClick={false} closeOnEsc={false} center
                >
                <UsePoint
                    contentSerial={contentSerial}
                    //contentPartSerial={contentPartSerial}
                    //subPartSerial2={subPartSerial2}
                    //subPartSerial3={subPartSerial3}
                    payGubun={payGubun}
                    chksale="all"
                    onPointUse = {this._setPointUse} 

                />
                </Modal> 
                */}
        </>
        {/* )} */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Items));
